import { useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Divider, Input, Select, Space } from 'antd';
import { useSelector } from "react-redux";
import utils from './utils';
import { APIClient } from "../helpers/api_helper";
import { useDispatch } from 'react-redux';
import { loadTags } from '../slices/thunk';


const api = new APIClient();


const TagsSelect = ({ value = [], onChange, multiple = false, size = null, minWidth = 200, allowCreate = true, placeholder = "Izberi oznako", excludeIds = [], allowNoValue = false }) => {

  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');

  const excludeSet = new Set(excludeIds);
  const baseOpts = utils.buildTagOptions(useSelector(state => state.Tags.list))
    .filter(opt => !excludeSet.has(opt.value));
  const baseById = utils.processBackendOptsById(useSelector(state => state.Tags.byId))

  // Opt-in "N/A" pseudo-option = rows with NO tag. FILTERS ONLY: it must never
  // appear on data-entry forms, where it would become an assignable value.
  const noValue = utils.noValueOption();
  // level: 0 keeps it flush left, above the tag tree; no color_hex -> no swatch.
  const opts = allowNoValue ? [noValue, ...baseOpts] : baseOpts;
  // Also in the by-id map, or the chip for `tags_filters=none` renders blank.
  const tagsById = allowNoValue ? { ...baseById, [noValue.value]: noValue } : baseById;

  const createAndSelectNew = (e) => {

    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;

    const exists = opts.some(opt => opt.value === trimmed);
    if (exists){
      return;
    }

    api.post('/api/tags/', {'title': trimmed}, {successMsg: `Oznaka ${trimmed} uspešno ustvarjena!`})
      .then(resp => {
        setName('');
        setOpen(false);
        onChange(resp?.id)
        dispatch(loadTags());  // so redux (app-wide) tags are updated!
      })
  };

  // When the value is set from outside, sometimes its an int[], sometimes just int
  // ALSO, value in the <Select> needs to be full object {'label': 'xoxo', value: 5} (and not just id)
  const selectedValues = Array.isArray(value)
      ? value.map(x => tagsById[x])
      : tagsById[value];

  return (
    <Select
      open={open}
      size={size}
      onDropdownVisibleChange={setOpen}
      mode={multiple ? "tags" : undefined}
      showSearch
      style={{ minWidth: minWidth, flex: 1}}
      placeholder={placeholder}
      optionFilterProp="label"
      value={selectedValues} // <-- this must be array of strings (values)
      onChange={onChange}
      options={opts}
      optionRender={option => (
        <span style={{ paddingLeft: (option.data?.level || 0) * 16 }}>
          {option.data?.color_hex && (
            <span
              style={{
                display: 'inline-block',
                width: 8,
                height: 8,
                borderRadius: 2,
                marginRight: 6,
                background: option.data.color_hex,
              }}
            />
          )}
          {option.data?.title}
        </span>
      )}
      allowClear
      dropdownRender={allowCreate ? (menu => (
        <>
          {menu}
          <Divider style={{ margin: '8px 0' }} />
          <Space style={{ padding: '0 8px 4px' }}>
            <Input
              placeholder="Vnesi novo oznako"
              ref={inputRef}
              value={name}
              onChange={e => setName(e.target.value)}
              onKeyDown={e => e.stopPropagation()}
            />
            <Button type="text" icon={<PlusOutlined />} onClick={createAndSelectNew}>
              Ustvari novo oznako
            </Button>
          </Space>
        </>
      )) : undefined}
    />
  );
};

export default TagsSelect;
